<script setup lang="ts">
import { Type, CardIcon } from '@Shared/components/visuals/utility';
import CogAroundSpanner from './visualAssets/CogAroundSpanner.svg?component';
import LoveHeartInSpeechBubble from './visualAssets/LoveHeartInSpeechBubble.svg?component';
import ThumbsDownInSpeechBubble from './visualAssets/ThumbsDownInSpeechBubble.svg?component';
import FourBoxesWithCheckmark_Positive from './visualAssets/FourBoxesWithCheckmark_Positive.svg?component';
import FourBoxesWithCheckmark_Negative from './visualAssets/FourBoxesWithCheckmark_Negative.svg?component';
import NpsPromotorStreak from './visualAssets/NpsPromotorStreak.svg?component';
import NpsDetractorStreak from './visualAssets/NpsDetractorStreak.svg?component';
import Clock from './visualAssets/Clock.svg?component';
import InsightCard from './skeletons/parts/InsightCard.vue';
import SadFaceWithThumbsDown from './visualAssets/SadFaceWithThumbsDown.svg?component';
import HappyFaceWithHeart from './visualAssets/HappyFaceWithHeart.svg?component';
import NeutralFaceWithArrows from './visualAssets/NeutralFaceWithArrows.svg?component';
import PromoterFaceWithArrow from './visualAssets/PromoterFaceWithArrow.svg?component';
import DetractorFaceWithArrows from './visualAssets/DetractorFaceWithArrows.svg?component';

const props = defineProps<{
  title: string;
  count: number;
  cards: {
    title: string;
    description: string;
    icon: CardIcon;
    type: Type;
  }[];
}>();

const getIconImg = (icon: CardIcon, type: Type) => {
  if (icon == CardIcon.FourBoxesWithCheckmark) {
    if (type == Type.Positive) {
      return FourBoxesWithCheckmark_Positive;
    } else {
      return FourBoxesWithCheckmark_Negative;
    }
  }
  if (icon == CardIcon.LoveHeartInSpeechBubble) {
    return LoveHeartInSpeechBubble;
  }
  if (icon == CardIcon.ThumbsDownInSpeechBubble) {
    return ThumbsDownInSpeechBubble;
  }
  if (icon == CardIcon.Clock) {
    return Clock;
  }
  if (icon == CardIcon.CogAroundSpanner) {
    return CogAroundSpanner;
  }
  if (icon == CardIcon.PromotorStreak) {
    return NpsPromotorStreak;
  }
  if (icon == CardIcon.DetractorStreak) {
    return NpsDetractorStreak;
  }
  if (icon == CardIcon.SadFaceWithThumbsDown) {
    return SadFaceWithThumbsDown;
  }
  if (icon == CardIcon.HappyFaceWithHeart) {
    return HappyFaceWithHeart;
  }
  if (icon == CardIcon.NeutralFaceWithArrows) {
    return NeutralFaceWithArrows;
  }
  if (icon == CardIcon.PromoterFaceWithArrow) {
    return PromoterFaceWithArrow;
  }
  if (icon == CardIcon.DetractorFaceWithArrows) {
    return DetractorFaceWithArrows;
  }
};
</script>
<template>
  <div class="flex flex-col box-border pt-2 px-4 justify-between color-[#4F4F4F] bg-[#CFD6E2] rounded-1">
    <div class="xl:text-4 xs:text-5 font-700 font-family[Poppins]">
      {{ title }}
    </div>
    <div class="mb-4 font-family[Roboto]">
      <div v-for="card in props.cards" class="mt-2 bg-[#FFFFFF] rounded-1" :key="card.title">
        <div class="ml-3 flex flex-row items-center">
          <component
            :is="getIconImg(card.icon, card.type)"
            class="h-[28px] w-[28px] min-w-[28px]"
            :class="{
              'color-[#D4002B]': card.type == Type.Negative,
              'color-[#0C8A65]': card.type == Type.Positive,
              'color-[#7F7466]': card.type == Type.Neutral,
            }"
          />
          <div class="flex flex-col pl-3 pr-4 xl:text-3 lg:text-3.5 xs:text-4">
            <div
              class="font-700 pt-3 uppercase break-all"
              :class="{
                'color-[#D4002B]': card.type == Type.Negative,
                'color-[#0C8A65]': card.type == Type.Positive,
                'color-[#7F7466]': card.type == Type.Neutral,
              }"
            >
              {{ card.title }}
            </div>
            <div class="mt-1 mb-3 font-400 color-[#4F4F4F]">
              {{ card.description }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="props.count == 1" class="mt-2 bg-[#FFFFFF] rounded-1">
        <InsightCard :showHasNoDataMessage="true" />
      </div>
    </div>
  </div>
</template>
